import { useEffect, useState } from "react";
import { ClockCountdown, Check } from "@phosphor-icons/react";
import { teleproApi } from "../../lib/teleproApi";

// VAGUE 44 — Créneau de rappel conseillé (historique + disponibilités + secteur), validé par le télépro.
export default function CallbackSuggestion({ biz, availability, onApply }) {
  const [s, setS] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => {
      teleproApi.get(`/me/businesses/${biz.id}/callback-suggestion`, { params: { availability: availability || "" } })
        .then((r) => setS(r.data)).catch(() => setS(null));
    }, 400);
    return () => clearTimeout(t);
  }, [biz.id, availability]);
  if (!s?.at) return null;
  const applied = biz.call?.callback_at && new Date(biz.call.callback_at).getTime() === new Date(s.at).getTime();
  return (
    <div className="mt-1.5 bg-[#C8795A]/10 border border-[#C8795A]/40 rounded-sm px-2.5 py-2 text-xs max-w-md" data-testid={`callback-suggestion-${biz.id}`}>
      <div className="flex flex-wrap items-center gap-2">
        <ClockCountdown size={13} weight="bold" className="text-[#C8795A]"/>
        <span>Créneau conseillé : <b data-testid={`callback-suggestion-label-${biz.id}`}>{s.label}</b></span>
        {applied ? (
          <span className="inline-flex items-center gap-1 text-[11px] font-bold text-primary"><Check size={11} weight="bold"/> Appliqué</span>
        ) : (
          <button type="button" onClick={() => onApply(s.at)}
            className="text-[11px] font-bold bg-[#C8795A] text-white rounded-sm px-2 py-1 hover:bg-[#a8603f]" data-testid={`callback-suggestion-apply-${biz.id}`}>
            Appliquer
          </button>
        )}
      </div>
      {s.reasons?.length > 0 && (
        <ul className="mt-1 text-[11px] text-foreground/75 list-disc list-inside" data-testid={`callback-suggestion-reasons-${biz.id}`}>
          {s.reasons.map((r) => <li key={r}>{r}</li>)}
        </ul>
      )}
    </div>
  );
}
